export default "__VITE_ASSET__BDP6Vog7__";